import { useMedicalChronology } from "@/components/MedicalChronology/contexts/MedicalChronologyContext";
import { useCaseChats } from "@/hooks/useCaseChats";
import React from "react";

import { ChatsView } from "./ChatsView";
import type { ChatsProps } from "./types";

export const Chats: React.FC<ChatsProps> = ({
  activeConversationId,
  onSelectConversation,
  onNewChat,
}) => {
  const { caseId } = useMedicalChronology();
  const { conversations, isLoading, error } = useCaseChats(caseId);

  return (
    <ChatsView
      conversations={conversations}
      loading={isLoading}
      error={error}
      activeConversationId={activeConversationId}
      onSelectConversation={onSelectConversation}
      onNewChat={onNewChat}
    />
  );
};
